import React, { Fragment } from 'react';
import PrintComponent from './Print';
import { Breadcrumbs } from '../../../../../../AbstractElements';

const Invoice = () => {
  return (
    <Fragment>
      <Breadcrumbs parent='Dashboard' title='Invoice' mainTitle='Invoice' />
      <PrintComponent />
    </Fragment>
  );
};
export default Invoice;
